import { useMutation, useQuery, useLazyQuery } from "@apollo/react-hooks";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Tooltip,
  Typography,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import BusinessImage from "../../../../Assets/Images/007.jpg";
import { Loader } from "../../../../Components/Loader";
import { CustIcon } from "../../../../Components/Svgs";
import {
  INSERT_BUSINESS,
  INSERT_ONBOARDING_ASSIST_REQUEST,
  UPDATE_BUSINESS,
  UPDATE_USER_LAST_SCREEN,
} from "../../../../Graphql/mutations";
import {
  GET_BUSINESS_BY_OWNER,
  GET_BUSINESS_TYPES,
  GET_USER_DETAILS,
  VALIDATE_REFCODE,
} from "../../../../Graphql/queries";
import "./BusinessDetails.less";

const { Option } = Select;
const { Title } = Typography;

export const OnboardingBusinessDetails = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [maxEmployee, setMaxEmployee] = useState(false);
  const user_id = localStorage.getItem("user_id");

  const { data: userData, loading: userDataLoading } = useQuery(
    GET_USER_DETAILS,
    {
      variables: { user_id: user_id },
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const { data, loading } = useQuery(GET_BUSINESS_TYPES, {
    fetchPolicy: "cache-and-network",
    context: {
      headers: {
        subscription: 1,
      },
    },
  });

  const { data: businessDetails, loading: businessDataLoading } = useQuery(
    GET_BUSINESS_BY_OWNER,
    {
      variables: {
        owner_id: user_id,
      },
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const [INSERT_BUSINESS_MUTATION, { loading: businessLoading }] = useMutation(
    INSERT_BUSINESS,
    {
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const [UPDATE_BUSINESS_MUTATION, { loading: businessupdating }] = useMutation(
    UPDATE_BUSINESS,
    {
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const [UPDATE_USER_LAST_SCREEN_MUTATION] = useMutation(
    UPDATE_USER_LAST_SCREEN,
    {
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const [INSERT_ONBOARDING_ASSIST_REQUEST_MUTATION] = useMutation(
    INSERT_ONBOARDING_ASSIST_REQUEST,
    {
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const { data: validateRefData } = useQuery(VALIDATE_REFCODE, {
    fetchPolicy: "cache-and-network",
    context: {
      headers: {
        subscription: 1,
      },
    },
  });

  useEffect(() => {
    if (businessDetails && !businessDetails?.business[0]?.owner?.last_screen) {
      UPDATE_USER_LAST_SCREEN_MUTATION({
        variables: {
          user_id: user_id,
          last_screen: history.location.pathname,
        },
      });
    }
    if (businessDetails) {
      form.setFieldsValue({
        name: businessDetails?.business[0]?.business_name,
        locations: businessDetails?.business[0]?.location_count,
        type_id: businessDetails?.business[0]?.business_type_id,
        referral_code: businessDetails?.business[0]?.ref_code,
      });
    }
  }, [businessDetails]);

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const tailLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onFinish = async (values) => {
    try {
      if (maxEmployee || values.locations > 10) {
        if (businessDetails?.business?.length === 0) {
          const refIndex = validateRefData.agent.findIndex(
            (itm) => itm.ref_code === values?.referral_code
          );
          if (refIndex < 0 && values?.referral_code) {
            message.error("Invalid Referral Code...");
            return;
          }
          const requestParams = {
            user_id: user_id,
            no_of_locations: values?.locations,
            business_name: values?.name,
            business_type_id: values?.type_id,
            isCompleted: false,
          };

          await INSERT_ONBOARDING_ASSIST_REQUEST_MUTATION({
            variables: {
              object: requestParams,
            },
          });
        }
        history.push("/on-boarding/thank-you");
      } else {
        if (businessDetails?.business?.length === 0) {
          const refIndex = validateRefData.agent.findIndex(
            (itm) => itm.ref_code === values?.referral_code
          );
          if (refIndex < 0 && values?.referral_code) {
            message.error("Invalid Referral Code...");
            return;
          }
          const response = await INSERT_BUSINESS_MUTATION({
            variables: {
              owner_id: user_id,
              location_count: values?.locations,
              business_name: values?.name,
              business_type_id: values?.type_id,
              referral_code: values?.referral_code,
            },
          });
          if (!response.errors) {
            history.push("/on-boarding/payment-plan");
          }
        } else {
          const refIndex = validateRefData.agent.findIndex(
            (itm) => itm.ref_code === values?.referral_code
          );
          if (refIndex < 0 && values?.referral_code) {
            message.error("Invalid Referral Code...");
            return;
          }
          const response = await UPDATE_BUSINESS_MUTATION({
            variables: {
              business_id: businessDetails?.business[0].business_id,
              location_count: values?.locations,
              business_name: values?.name,
              business_type_id: values?.type_id,
              owner_id: user_id,
              referral_code: values?.referral_code,
            },
          });
          if (!response.errors) {
            history.push("/on-boarding/payment-plan");
          }
        }
      }
    } catch (error) {
      message.error("Something went wrong...");
    }
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={BusinessImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        {businessDataLoading ? (
          <Loader />
        ) : (
          <div className="step_3">
            <p className="text-right text-step">Step 3 of 6</p>
            <Title level={2}>
              {`Hello, ${
                !userDataLoading && userData
                  ? userData?.getUsersById?.first_name
                  : ""
              }`}
            </Title>
            <p className="subTitle">
              Fill out some basic details about your business.
            </p>

            <Form {...layout} name="basic" form={form} onFinish={onFinish}>
              <Row gutter={16}>
                <Col xs={24} sm={24}>
                  <Form.Item
                    label={
                      <Fragment>
                        Business Name
                        {/* <Tooltip title="Business Name" key={2}>
                          <span>
                            <CustIcon
                              type="info"
                              className="ml-3 text-danger"
                            />
                          </span>
                        </Tooltip> */}
                      </Fragment>
                    }
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter business name!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, Sanattest Corp." />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24}>
                  <Form.Item
                    label={
                      <Fragment>
                        Sales/Agent Code (Optional)
                        <Tooltip
                          title="If someone who is already using SanAttest has referred you OR if you have a SanAttest sales agent referral code, please enter here. It will give you discounts later on!"
                          key={2}
                        >
                          <span>
                            <CustIcon
                              type="info"
                              className="ml-3 text-danger"
                            />
                          </span>
                        </Tooltip>
                      </Fragment>
                    }
                    name="referral_code"
                    rules={[
                      {
                        required: false,
                        message: "Please enter referral code!",
                      },
                    ]}
                  >
                    <Input placeholder="e.g, xy12#A" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={
                      <Fragment>
                        Number of locations
                        {/* <Tooltip title="Number of locations" key={2}>
                          <span>
                            <CustIcon
                              type="info"
                              className="ml-3 text-danger"
                            />
                          </span>
                        </Tooltip> */}
                      </Fragment>
                    }
                    name="locations"
                    rules={[
                      {
                        required: true,
                        message: "Please enter number of locations!",
                      },
                    ]}
                  >
                    <InputNumber min={1} placeholder="e.g, 1,2,3..." />
                  </Form.Item>
                </Col>
              </Row>
              {/* <div className="mb-3 stepCheckbox">
                <Checkbox
                  className="typeCheckboxGroup"
                  checked={maxEmployee}
                  onClick={() => setMaxEmployee(!maxEmployee)}
                >
                  Tick here ONLY if ANY ONE of your locations has more than 50
                  employees. We’ll help you get set up!
                </Checkbox>
              </div> */}
              <Form.Item
                label={
                  <Fragment>
                    Business Type
                    {/* <Tooltip title="Business Type" key={1}>
                      <span>
                        <CustIcon type="info" className="ml-3 text-danger" />
                      </span>
                    </Tooltip> */}
                  </Fragment>
                }
                name="type_id"
                rules={[
                  {
                    required: true,
                    message: "Please select at least one business type!",
                    whitespace: true,
                  },
                ]}
              >
                <Select
                  placeholder="Select Business Type"
                  optionFilterProp="children"
                >
                  {loading
                    ? "Loading..."
                    : !loading &&
                      data?.business_types.map((type, index) => (
                        <Option key={index} value={type?.id}>
                          {type?.name}
                          {type?.description && (
                            <small> ({`${type?.description}`})</small>
                          )}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
              <Form.Item
                className="businessInfoContainer"
                label={
                  <span className="businessInfo">
                    Each location can have maximum 50 employees. If you have
                    more than 50 employees in 1 location, then add the relevant
                    location count. You need to pay for the locations in next
                    step.
                  </span>
                }
              ></Form.Item>
              <Form.Item {...tailLayout} className="buttonSec">
                <Button
                  loading={businessLoading || businessupdating}
                  type="primary"
                  shape="round"
                  htmlType="submit"
                  size="large"
                >
                  {" "}
                  {businessLoading || businessupdating
                    ? "Submitting"
                    : "Continue"}
                </Button>
              </Form.Item>
            </Form>
          </div>
        )}
      </div>
    </div>
  );
};
